import axios from 'axios';

export default {
  token: (params) => axios.get('/api/v1/one/project-milestone-token', { params }),
  getById: (id) => axios.get(`/api/v1/one/project-milestone/${id}`),
  getHistoryById: (id) => axios.get(`/api/v1/one/project-milestone/${id}/history`),
  resetHistory: (id, historyId) => axios.post(`/api/v1/one/project-milestone/${id}/history/${historyId}`),
  generateHistoryPDF: (id) => axios.post(`/api/v1/one/project-milestone-history/${id}/pdf`),
  create: (params) => axios.post('/api/v1/one/project-milestone', params, { headers: { 'Content-Type': 'multipart/form-data' } }),
  submit: (params, id, query = {}) =>
    axios.post(`/api/v1/one/project-milestone/${id}`, params, { params: query, headers: { 'Content-Type': 'multipart/form-data' } }),
  updateFields: (params, id) => axios.put(`/api/v1/one/project-milestone/${id}`, params, { headers: { 'Content-Type': 'multipart/form-data' } }),
  updateInfo: (params, id) => axios.patch(`/api/v1/one/project-milestone/${id}`, params, { headers: { 'Content-Type': 'multipart/form-data' } }),
  confirm: (params) => axios.put(`/api/v1/one/project-milestone/${params.id}/confirmation/${params.key}`, { value: params.value }),
  getConfirm: (id) => axios.get(`/api/v1/one/project-milestone/${id}/confirmation`),
  delete: (id) => axios.delete(`/api/v1/one/project-milestone/${id}`),
  getTranslatedPDF: ({ id, language }) => axios.get(`/api/v1/one/project-milestone/${id}/translate-pdf/${language}`),
};
